import { Controller } from "@hotwired/stimulus"
import { useDebounce } from "stimulus-use"

// Connects to data-controller="form-select"
export default class extends Controller {
  static debounces = ["submit_with_debounce"]

  connect() {
    useDebounce(this, { wait: 800 })
  }

  submit() {
    this.element.requestSubmit()
  }

  reset() {
    this.element.reset()
  }

  submit_with_debounce() {
    this.element.requestSubmit()
  }
}
